import { render, staticRenderFns } from "./stockcards.vue?vue&type=template&id=2e84912a&"
import script from "./stockcards.vue?vue&type=script&lang=js&"
export * from "./stockcards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports